import {TranslateService} from "@ngx-translate/core";

export class SecurityPerUser{
  userName: string;
  passwordWillExpire = true;
  passwordExpirationInDays = 90;
  failedLoginDeactivateAccount = true;
  nbMaxOfFailedLogin = 3;
  minSizePwd = 8;
  minNbUpperCase = 1;
  minNbLowerCase = 1;
  minSpecialChar = 1;
  minNumberDigit = 1;
  changePasswordNextLogin = false; //Wont be saved in DB.

  public explain(translate: TranslateService): string{
    let res = '';
     if (this.passwordWillExpire){
        res += translate.instant('PasswordWillExpireAfter',{passwordExpirationInDays:this.passwordExpirationInDays})
      }else{
        res += translate.instant('PasswordWillNotExpire')
      }
      res +=' ';
      if (this.failedLoginDeactivateAccount){
        res += translate.instant('AccountWillBeDeactivated',{nbMaxOfFailedLogin: this.nbMaxOfFailedLogin})
      }else{
        res += translate.instant('NoLimitForFailedLogin');
      }
      res += ' ';
      res += this.explainPassword(translate);
     return res;
  }


  public explainPassword(translate: TranslateService): string{
    let res = '';
    if (this.minSizePwd<=0){
      res += translate.instant('NoPasswordRules');
    }else{
      if (this.minSpecialChar>0 || this.minNumberDigit >0 || this.minNbUpperCase > 0 || this.minNbLowerCase > 0){
        res += translate.instant('PasswordRules',{minSizePwd: this.minSizePwd,
          minNbUpperCase:this.minNbUpperCase,minNbLowerCase:this.minNbLowerCase,
          minSpecialChar:this.minSpecialChar,minNumberDigit:this.minNumberDigit})
      }else{
        res += translate.instant('PasswordRulesLen',{minSizePwd: this.minSizePwd})

      }
    }
    return res;
  }

}
